import packageJson from '../../package.json';

const APP_VERSION = packageJson.version

const LOCALSTORAGE = {
  // @nome_aplicação:nome_variável-versão_aplicação
  app: `@yelly-sistema-checkout:app-${APP_VERSION}`,
  purchaserData: `@yelly-sistema-checkout:purchaserData-${APP_VERSION}`,
  cepData: `@yelly-sistema-checkout:cepData-${APP_VERSION}`,
}

export type ILocalStorageApp = {
  accountable: string,
  accountable_document: string,
  address: string,
  createdAt: string,
  document: string,
  domain: string,
  id: string,
  logo:string,
  name: string,
  primaryColor: string,
  secondaryColor: string,
  updatedAt: string,
} | null;

export const Constants = {
  LOCALSTORAGE,
}